
let Config = {
    apiPrefix: 'http://127.0.0.1:5000/'
}
const logo = 'https://paoying.oss-cn-beijing.aliyuncs.com/logo.png'

export default Config;
export {logo}